import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { FormValidations } from "../../../shared/form-validation/form-validation";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { PersonalDataService } from "../../service/personal-data.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";

@Component({
  selector: "app-parentage",
  templateUrl: "./parentage.component.html",
  styleUrls: ["./parentage.component.scss"],
})
export class ParentageComponent extends DefaultPageComponent implements OnInit {
  public motherName = "";
  public idComponentParentage = "documentParentage";
  placeholder = "Escreva o nome da sua mãe";
  error = false;
  buttonEnable = false;
  textError = "";
  minLengthErrorText = "Esse nome está incompleto";
  invalidErrorText = "Nome inválido";
  maxLengthErrorText =
    "Limite de caracteres alcançado, você pode abreviar os nomes do meio";
  idLabel = "parentageName";
  label = "nome da mãe";
  headerId = "parentage";
  titlePage = "Dados pessoais";
  startStage = "";
  endStage = "";
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  idLabelParentage = "labelParentage";
  idButtonParentage = "buttonParentage";

  parentageForm = this.formBuilder.group({
    docParentage: this.formBuilder.control("", [
      FormValidations.checkMotherName,
      FormValidations.validationsName,
    ]),
  });

  constructor(
    public router: NavController,
    private personalDataService: PersonalDataService,
    public backNativeService: BackNativeService,
    public returnNativeService: ReturnNativeService,
    private formBuilder: FormBuilder,
    private title: Title,
    public journeyService: JourneyService,
    public analycticsNativeService: AnalycticsNativeService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.getTrack();
  }

  /* istanbul ignore next */
  get docName() {
    return this.parentageForm.get("docParentage");
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.editFieldInvest("nome_mae", "motherName", "personalData");
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = "personal-data";

    if (
      this.journeyService.journey === TrackTypes.CONTA_ION ||
      this.journeyService.journey === TrackTypes.CONTA_ION_PERSONAL
    ) {
      this.startStage = "6";
      this.endStage = "11";
    } else {
      this.startStage = (
        track.getIndexPage(this.headerId, path) - 1
      ).toString();
      this.endStage = (track.getTotalPage(path) - 1).toString();
    }
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.motherName;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathNomeMae,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    this.personalDataService.setParentage(this.motherName.trim());
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.motherName,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  errorMsg() {
    const control = this.parentageForm.get("docParentage") as FormControl;
    this.error = control.errors !== null;

    this.error ? (this.buttonEnable = false) : (this.buttonEnable = true);

    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("checkShortNameMin")
    ) {
      this.textError = this.minLengthErrorText;
    }

    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("checkShortNameMax")
    ) {
      this.textError = this.maxLengthErrorText;
    }

    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("nameLastname")
    ) {
      this.textError = this.minLengthErrorText;
    }

    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("maxNinename")
    ) {
      this.textError = this.invalidErrorText;
    }

    if (control.errors !== null && control.errors.hasOwnProperty("nameSpace")) {
      this.textError = this.invalidErrorText;
    }
  }

  getPageId(): string {
    return this.headerId;
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.personalData.motherName) {
      this.motherName =
        this.journeyService.registratioJourney.data.personalData.motherName;
      this.parentageForm.controls.docParentage.setValue(
        this.journeyService.registratioJourney.data.personalData.motherName
      );
      this.errorMsg();
    }
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }
}
